// extracted by mini-css-extract-plugin
export default {"headerBackground":"SalesHeader_headerBackground__YuKAW","headerContainer":"SalesHeader_headerContainer__AVbj6","headerWrapper":"SalesHeader_headerWrapper__dqsgu"};